"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiveTask = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BPMN ReceiveTask.
 *
 * A ReceiveTask is basically the opposite of a SendTask.
 * It will block the Process Execution, until an expected Message is
 * received.
 *
 * In contrast to an IntermediateCatchEvent, a ReceiveTask will
 * throw back a confirmation Message that the ReceiveTask received the
 * defined message.
 * Therefore, a ReceiveTask will only accept messages, that where send by
 * a SendTask.
 */
class ReceiveTask extends ActivityBase_1.Activity {
    get bpmnType() {
        return Constants_1.BpmnType.receiveTask;
    }
}
exports.ReceiveTask = ReceiveTask;
//# sourceMappingURL=ReceiveTask.js.map